import React, { memo } from "react"
import styled from "styled-components"

import { Paragraph } from "components/text"
import Icon from "components/icon"
import { Flex } from "components/box"
import { BrowserView } from "components/helpers/hide"

import NavigationDropdown from "./navigation-dropdown"
import RightDropdownMenu from "./menus/right-menu"

import { useOpen } from "hooks/useOpen"

const Logo = styled(Icon)`
  svg {
    height: 1.875rem;
    width: 1.875rem;
  }
`

const RightNavigationPanelLoggedIn = ({ fullName }: { fullName: string }) => {
  const { isOpen, handleClose, handleToggle } = useOpen()

  return (
    <NavigationDropdown
      isOpen={isOpen}
      handleClose={handleClose}
      openedDropdownContent={<RightDropdownMenu handleClose={handleClose} />}
    >
      <Flex alignItems="center" onClick={handleToggle}>
        <Logo name="avatar" />

        <BrowserView>
          <Flex ml={4}>
            <Paragraph>{fullName}</Paragraph>
            <Logo name="arrowDown" ml={4} />
          </Flex>
        </BrowserView>
      </Flex>
    </NavigationDropdown>
  )
}

export default memo(RightNavigationPanelLoggedIn)
